/*
 * @Author: guozhenqiang 15138913894@163.com
 * @Date: 2023-04-23 09:36:44
 * @LastEditors: guozhenqiang 15138913894@163.com
 * @LastEditTime: 2023-04-27 11:33:09
 * @FilePath: \baichuan-website\src\utils\commonData.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const COMMONDATA = {
  videoUrl: 'https://daidai-energy.oss-cn-zhangjiakou.aliyuncs.com/video/yewujieshao.mp4',
  envideoUrl: 'https://daidai-energy.oss-cn-zhangjiakou.aliyuncs.com/video/yewujieshao-en.mp4',
  chinaDataUrl: `${location.origin}/api/uploadeview/china.json`
}
export {
  COMMONDATA
};



// WEBPACK FOOTER //
// ./src/utils/commonData.js